import { render, staticRenderFns } from "./DIDSettings.vue?vue&type=template&id=340ae3f1&scoped=true&"
import script from "./DIDSettings.vue?vue&type=script&lang=js&"
export * from "./DIDSettings.vue?vue&type=script&lang=js&"
import style0 from "./DIDSettings.vue?vue&type=style&index=0&id=340ae3f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340ae3f1",
  null
  
)

export default component.exports